var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed-footer"},[_c('div',{staticClass:"content_wrap"},[_c('p',[_c('span',[_vm._v(_vm._s(_vm.tougaoSetting.organizer_address))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }